/* eslint-disable indent */
// selectors
const bodyEl = document.querySelector("body");
const gridFiltersParentContainer = document.querySelector(".grid-filters-container");
const mobileTrigger = document.querySelector(".grid-filters-button-trigger");
const mobileFiltersClose = document.querySelector(".grid-filters-button-close");
const panel = document.querySelector(".grid-filters-panel-container");
const nestedMenuListTrigger = document.querySelectorAll(".button-toggle-content-display");
const filterLabelTemplate = document.querySelector('[data-model="filter-label-template"');
const filterLabelList = document.querySelector(".grid-filters-labels-list");
const clearFiltersButton = document.querySelector('[name="clear-filters"]');
const applyFiltersButton = document.querySelector('[name="apply-filters"]');
const gridFiltersCountContainer = document.querySelectorAll(".grid-filters-count-container");
const gridFilterGroups = panel ? panel.querySelectorAll('[role="group"]') : null;
const gridFiltersCount = document.querySelectorAll(".grid-filters-count");
const navTopBar = document.getElementById("top-bar");

// flags
let mobileContainerOpened = false;

// the function below:
// 1. creates the active filter pill,
// 2. uses the label text for its text
// 3. generates a data-name attribute
// 4. places this new pill in the list with the others
function cloneFilterLabel(template, list, label, name) {
	let clonedLabel = template.cloneNode(true);
	clonedLabel.dataset.name = name;
	let span = clonedLabel.querySelector("span");
	span.textContent = label;
	list.append(clonedLabel);
	return template;
}

function updateActiveFiltersCount() {
	let count = 0;
	let activeFilters = document.querySelectorAll(".grid-filters-labels-list-item");
	count = activeFilters.length;
	gridFiltersCount.forEach((item) => {
		item.textContent = count;
		if (count === 0) {
			clearFiltersButton.disabled = true;
			gridFiltersCountContainer.forEach((item) => {
				item.classList.add("hidden");
			});
		} else if (count > 0) {
			clearFiltersButton.disabled = false;
			gridFiltersCountContainer.forEach((item) => {
				item.classList.remove("hidden");
			});
		}
	});
	return count;
}

function updateActiveFiltersCountWithinSection() {
	if (!gridFilterGroups) {
		return;
	}

	gridFilterGroups.forEach((item) => {
		let filterCount = 0;
		let parent = item.parentNode;
		let counter = parent.querySelector(".grid-filters-section-count");
		let counterContainer = parent.querySelector(".grid-filters-section-count-container");
		let checkboxList = item.querySelectorAll(".facetwp-checkbox:not(.facetwp-checkbox-exclusive)");
		checkboxList.forEach((el) => {
			if (el.classList.contains("checked")) {
				filterCount++;
			}
		});
		counter.textContent = filterCount;
		filterCount > 0 ? counterContainer.classList.remove("hidden") : counterContainer.classList.add("hidden");
	});
	return;
}

function openMobileFiltersPanel() {
	panel.classList.add("opened");
	gridFiltersParentContainer.classList.add("mobile-expanded");
	bodyEl.classList.add("scroll-lock");
	navTopBar.classList.add("hide-top-bar");
	return (mobileContainerOpened = true);
}

function closeMobileFiltersPanel() {
	panel.classList.remove("opened");
	gridFiltersParentContainer.classList.remove("mobile-expanded");
	bodyEl.classList.remove("scroll-lock");
	navTopBar.classList.remove("hide-top-bar");
	return (mobileContainerOpened = false);
}

// need to activate the remove filter pill button so that the user can click to
// 1. remove the pill from the active filters pill list
function setListenerToRemoveActiveFilterAndUncheckMatch() {
	let removeFilterButtons = document.querySelectorAll(".button-remove-filter");
	if (removeFilterButtons) {
		removeFilterButtons.forEach((item) => {
			item.addEventListener("click", () => {
				let parent = item.parentNode;
				let name = parent.getAttribute("data-name");

				document.querySelector('.facetwp-checkbox[data-value="' + name + '"]').click();
				parent.remove();
			});
		});
	}
}

// mobile and desktop basic functionality here
const mql = window.matchMedia("(min-width: 64em)");
// need to open all filters as a group in desktop
if (mql.matches) {
	// the width of browser is more than 62em
	nestedMenuListTrigger.forEach((item) => {
		item.addEventListener("click", () => {
			panel.classList.toggle("expand-all");
		});
	});
	// but in mobile each filter group should open individually
} else {
	// the width of browser is less than 62em
	nestedMenuListTrigger.forEach((item) => {
		item.addEventListener("click", () => {
			item.classList.toggle("expanded");
		});
	});
}

// filter fun starts here
// don't need to display the active filter template on load,
// it exists in memory so we can use it as a template to populate list of active filters
//filterLabelTemplate.remove();

if (mobileTrigger) {
	mobileTrigger.addEventListener(
		"click",
		() => {
			mobileContainerOpened ? closeMobileFiltersPanel() : openMobileFiltersPanel();
		},
		false,
	);
}

if (mobileFiltersClose) {
	mobileFiltersClose.addEventListener(
		"click",
		() => {
			if (mobileContainerOpened) {
				closeMobileFiltersPanel();
			}
		},
		false,
	);
}

if (applyFiltersButton) {
	applyFiltersButton.addEventListener(
		"click",
		() => {
			if (mobileContainerOpened) {
				closeMobileFiltersPanel();
			}
		},
		false,
	);
}

if (clearFiltersButton) {
	clearFiltersButton.addEventListener("click", () => {
		let FWP = window.FWP;
		FWP.reset();
		let labelsList = document.querySelectorAll(".grid-filters-labels-list-item");
		labelsList.forEach((el) => {
			el.remove();
		});
		updateActiveFiltersCountWithinSection();
		updateActiveFiltersCount();
		return;
	});
}

document.addEventListener("click", function (event) {
	if (!document.getElementsByClassName("search-results").length > 0) {
		let isClickInside = gridFiltersParentContainer.contains(event.target);

		if (isClickInside) {
			// clicked inside - do nothing
		} else {
			if (panel.classList.contains("expand-all")) {
				document.querySelector(".button-toggle-content-display").click();
			}
		}
	}
});

//let jQuery

(function ($) {
	// remove all labels
	if (document.querySelector(".grid-filters-labels-list-item")) {
		document.querySelectorAll(".grid-filters-labels-list-item").forEach((label) => {
			label.remove();
		});
	}

	$(document).on("facetwp-loaded", function () {
		const allCheckboxes = document.querySelectorAll(".facetwp-checkbox:not(.facetwp-checkbox-exclusive)");

		// remove all labels
		document.querySelectorAll(".grid-filters-labels-list-item").forEach((label) => {
			label.remove();
		});

		// set active labels
		allCheckboxes.forEach((item) => {
			let filterText = item.querySelector(".facetwp-display-value").textContent;
			let name = item.getAttribute("data-value");

			if (item.classList.contains("checked")) {
				if (!document.querySelector('.grid-filters-labels-list-item[data-name="' + name + '"]')) {
					cloneFilterLabel(filterLabelTemplate, filterLabelList, filterText, name);
				}
			}
		});

		setListenerToRemoveActiveFilterAndUncheckMatch();
		updateActiveFiltersCountWithinSection();
		updateActiveFiltersCount();
	});
})(jQuery);
